import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import PropTypes from 'prop-types';

import NewTile from './NewTile';
import { PlanLeftSectionTilesWrapper } from './StyledComponents';
import { SmallDroppableTileList } from '../../../../shared/SmallTile';

const UnscheduledTilesContainer = ({ tiles, activeTab, activeStatus }) => {
  const unscheduledTilesState = 'plan';
  const planTiles = tiles[unscheduledTilesState].tiles;
  const unscheduledTiles = planTiles.filter(tile => tile.planDate === null);
  const tilesPerRow = 1;
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(
    unscheduledTiles.length > pageNumber * pageSize,
  );

  useEffect(() => {
    const calculatePageSize = () => {
      const width = document.documentElement.clientWidth;
      const initialPageSize = width < 2048 ? 7 : 8;

      setPageSize(initialPageSize);
    };

    window.addEventListener('resize', calculatePageSize);
  }, []);

  const handleLoadMore = () => {
    setLoading(true);
    setPageNumber(previousPageNumber => previousPageNumber + 1);

    if (pageNumber > 1 && pageSize === 7) {
      setPageSize(8);
    }

    setHasNextPage(unscheduledTiles.length > pageNumber * pageSize);
    setTimeout(() => setLoading(false), 200);
  };

  const [infiniteRef] = useInfiniteScroll({
    loading,
    hasNextPage,
    onLoadMore: handleLoadMore,
    scrollContainer: 'parent',
  });

  return (
    <PlanLeftSectionTilesWrapper
      ref={infiniteRef}
      className="unscheduled-tiles-container"
      active={activeTab === 'unscheduled'}
    >
      <NewTile />
      <SmallDroppableTileList
        bucketDate="0000-00-00"
        pageNumber={pageNumber}
        pageSize={pageSize}
        tilesPerRow={tilesPerRow}
        activeStatus={activeStatus}
      />
    </PlanLeftSectionTilesWrapper>
  );
};

UnscheduledTilesContainer.propTypes = {
  tiles: PropTypes.object,
  activeTab: PropTypes.string,
};

const mapStateToProps = state => ({
  tiles: state.tiles.tiles,
  activeStatus: state.status.activeStatus,
});

export { UnscheduledTilesContainer };
export default connect(mapStateToProps)(UnscheduledTilesContainer);
